import { Configuration } from 'app/shared/models/configuration.model';

export class TenantConfiguration {
    contextName: string;
    configurations: Configuration[]
}



// WEBPACK FOOTER //
// ./src/app/shared/models/tenant-configuration.model.ts